export const DUPLICATE_FROM_PARAM = 'duplicateFrom';
